import { useMemo } from "react";
import { entityBasePath } from "@core/constants/pageBreadcrumb";
import { useScope } from "@core/hooks/useRouteParamId";

/**
 * Entity workspace root for the current route (`/nation|:church|:district/:id`),
 * or `undefined` when the URL is not an entity-scoped path.
 */
export function useEntityBasePath(): string | undefined {
  const scope = useScope();
  return useMemo(
    () => (scope ? entityBasePath(scope.scope, scope.scopeId) : undefined),
    [scope]
  );
}
